import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, Teleport as _Teleport, createSlots as _createSlots, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, normalizeClass as _normalizeClass, isRef as _isRef } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "course-lesson-page container-fix-padding bg-white h-full" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "practice-preparing",
  role: "status"
}
const _hoisted_7 = { class: "position-relative" }
const _hoisted_8 = {
  key: 0,
  class: "text-center position-absolute w-full d-flex justify-space-between align-center",
  style: {"top":"120px","z-index":"2","padding-right":"0px","pointer-events":"none"}
}
const _hoisted_9 = {
  key: 1,
  class: "w-100"
}
const _hoisted_10 = {
  key: 2,
  class: "d-flex",
  id: "classroom-lesson-body"
}
const _hoisted_11 = { class: "p-0 col-sm-12 col-lg-9 col" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "bg-white d-flex flex-column" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "youtube-video h-full w-full"
}
const _hoisted_17 = {
  key: 0,
  class: "youtube-video h-full w-full"
}
const _hoisted_18 = {
  key: 1,
  class: "vimeo-video h-full w-full"
}
const _hoisted_19 = { class: "bg-white my-4 p-2" }
const _hoisted_20 = { class: "container" }
const _hoisted_21 = { class: "h3 fv-blod" }
const _hoisted_22 = { class: "subtitle" }
const _hoisted_23 = { class: "subtitle-info" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = {
  key: 2,
  class: "return-goal-row"
}
const _hoisted_27 = { class: "return-goal-btn__label" }
const _hoisted_28 = {
  class: "btn-group btn-group-sm bg-secondary",
  role: "group"
}
const _hoisted_29 = {
  class: "modal fade lessonTabModal",
  id: "subtitleModal",
  tabindex: "-1",
  "aria-labelledby": "概要",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = { class: "modal-body pe-5" }
const _hoisted_33 = { class: "h4 fv-blod" }
const _hoisted_34 = { class: "container-fluid py-3" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "container-fluid" }
const _hoisted_37 = { class: "row align-items-center" }
const _hoisted_38 = { class: "col-12 col-lg-7" }
const _hoisted_39 = {
  key: 0,
  class: "lessonComment container py-2"
}
const _hoisted_40 = {
  class: "modal fade lessonTabModal",
  id: "live_chat",
  tabindex: "-1",
  "aria-labelledby": "Live Chat",
  "aria-hidden": "true"
}
const _hoisted_41 = { class: "modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen bg-white" }
const _hoisted_42 = { class: "modal-content" }
const _hoisted_43 = { class: "modal-body pe-5" }
const _hoisted_44 = {
  key: 1,
  class: "lessonComment container py-2"
}
const _hoisted_45 = {
  class: "modal fade lessonTabModal",
  id: "ai_chat",
  tabindex: "-1",
  "aria-labelledby": "AIチャット",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen bg-white" }
const _hoisted_47 = { class: "modal-content" }
const _hoisted_48 = { class: "modal-body" }
const _hoisted_49 = { class: "lessonComment container py-2" }
const _hoisted_50 = { class: "d-flex justify-content-between align-items-center fs-6" }
const _hoisted_51 = { class: "text-dark" }
const _hoisted_52 = {
  class: "modal fade lessonTabModal",
  id: "commentModal",
  tabindex: "-1",
  "aria-labelledby": "コメント一覧",
  "aria-hidden": "true"
}
const _hoisted_53 = { class: "h-100 modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen" }
const _hoisted_54 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_55 = { class: "modal-header" }
const _hoisted_56 = {
  class: "h5 mb-0 modal-title",
  id: "commentModalLabel"
}
const _hoisted_57 = { class: "modal-body pe-5" }
const _hoisted_58 = { class: "row align-items-center" }
const _hoisted_59 = { class: "col-2" }
const _hoisted_60 = ["src"]
const _hoisted_61 = {
  key: 2,
  class: "modal-content"
}
const _hoisted_62 = { class: "modal-body pe-5" }
const _hoisted_63 = {
  key: 2,
  class: "material-list container py-2"
}
const _hoisted_64 = {
  "aria-label": "素材一覧",
  "data-bs-toggle": "modal",
  "data-bs-target": "#materialModal",
  class: "w-100"
}
const _hoisted_65 = { class: "d-flex justify-content-between align-items-center fs-6" }
const _hoisted_66 = { class: "text-dark" }
const _hoisted_67 = {
  class: "modal fade lessonTabModal",
  id: "materialModal",
  tabindex: "-1",
  "aria-labelledby": "素材一覧",
  "aria-hidden": "true"
}
const _hoisted_68 = { class: "modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen" }
const _hoisted_69 = { class: "modal-content" }
const _hoisted_70 = { class: "modal-body pe-5" }
const _hoisted_71 = {
  key: 0,
  class: "container"
}
const _hoisted_72 = { class: "v-list-item-action" }
const _hoisted_73 = { class: "v-list-item-action" }
const _hoisted_74 = { class: "v-list-item-action" }
const _hoisted_75 = { class: "v-list-item-action" }
const _hoisted_76 = {
  key: 3,
  class: "container section-md-body"
}
const _hoisted_77 = { class: "pb-4 mb-5 tutorial-box" }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = {
  key: 4,
  class: "text-center pt-5 py-1"
}
const _hoisted_80 = { class: "d-flex align-center" }
const _hoisted_81 = { class: "d-flex align-center" }
const _hoisted_82 = { class: "w-full d-flex justify-space-between align-center" }
const _hoisted_83 = { class: "d-flex align-center gap-3" }
const _hoisted_84 = ["src"]
const _hoisted_85 = { class: "d-flex justify-end w-full" }
const _hoisted_86 = { class: "text-left" }
const _hoisted_87 = { class: "d-flex align-center gap-3" }
const _hoisted_88 = ["src"]
const _hoisted_89 = { class: "d-flex align-center gap-3" }
const _hoisted_90 = ["src"]
const _hoisted_91 = ["innerHTML"]
const _hoisted_92 = {
  key: 1,
  class: "d-flex align-center justify-center",
  style: {"height":"70vh"}
}

import { ref, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import UserQuestionList from '../organisms/UserQuestionList.vue'
import UserQuestionFormView from '../organisms/UserQuestionFormView.vue'
import ReviewDialog from '../organisms/ReviewDialog.vue'
import ReviewEditDialog from '../organisms/ReviewEditDialog.vue'
import CommentContainer from '../organisms/CommentContainer.vue'
import UserQuestionDetailModal from '../organisms/UserQuestionDetailModal.vue'
import { useCourseMyDetail } from '../../composables/useCourseMyDetail'
import useHighlightActions from '../../composables/useHighlightActions'
import UserQuestion from '../../../api/v2/models/user_question'
import LessonPracticeHistory from '../organisms/LessonPracticeHistory.vue'
import ExamArtifactWorkspace from '../organisms/ExamArtifactWorkspace.vue'
import { useClassroomPractice } from '../../composables/useClassroomPractice'
import TeacherView from '../atoms_molecules/TeacherView.vue'
import MesageContainer from '../organisms/MesageContainer.vue'
import LiveChat from "../organisms/LiveChat.vue"
import { eventBus, EVENTS } from '../../utils/eventBus'
import api from '../../../api/v2/api'
import trackingLesson from '../../trackings/lesson'

import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CourseMyDetailMobile',
  setup(__props) {

const { activeView, setPracticeView, setLessonExamView, practiceDiscussion, discussPractice, practiceHistoryRevision, refreshPracticeHistory, practiceExamId, practiceGenerating, showPractice, openPractice, setLatestPractice, onPracticeGenerating, returnToLesson } = useClassroomPractice()
const route = useRoute()
const courseIdStr = computed(() => Array.isArray(route.params.courseId) ? route.params.courseId[0] : route.params.courseId)

// Use the composable
const {
  mobile, course, courseLessons, currentLesson, courseMaterials, lessonMaterials,
  completedLessonCount, banners, review, chapters, isMobile, leftDrawer, rightDrawer,
  disabledNextBtn, disabledPreviousBtn, tab, currentLessonQuestionsCount,
  leftBarItems, lazyLoading,
  user, schoolSetting, headerNavColor, headerNavTextColor, hamburgerColor,
  lessonIdQuery, lessonIdQueryNumber, currentLessonId, headerTitle,
  goNextLesson, previousLession, getBanner, goLesson, downloadFile, goToHome, onResize,
  finishLesson, revertFinishLesson, returnGoal, goBackToGoal, upVote, downVote, refetchQuestionsCount,
  initializeDefaultTab, updateReview, initCourse, markdownParser,
  onVideoPlay, onVideoPause, onVideoMilestone
} = useCourseMyDetail()

const { codeDialog, dialogHTML } = useHighlightActions()

const currentQuestion = ref<UserQuestion | null>(null)
const questionMode = ref<'list' | 'show' | 'new'>('list')
const newQuestionCreatedFlag = ref(false)
const isShowAll = ref<boolean | null>(null)

const onClickQuestion = (question: UserQuestion) => {
  currentQuestion.value = question
  questionMode.value = 'show'
  newQuestionCreatedFlag.value = false
}

const onClickNewQuestion = () => {
  questionMode.value = 'new'
  newQuestionCreatedFlag.value = false
}

const onBackQuestionList = () => {
  currentQuestion.value = null
  questionMode.value = 'list'
  newQuestionCreatedFlag.value = false
}

const handleQuestionCreated = (question: UserQuestion) => {
  currentQuestion.value = question
  questionMode.value = 'show'
  newQuestionCreatedFlag.value = true
}

const toggleShowAll = () => {
  isShowAll.value = !isShowAll.value
}

// Watch route changes
watch(() => route.query, async (newQuery, oldQuery) => {
  if (newQuery.lesson_id && newQuery.lesson_id === oldQuery?.lesson_id) return
  if (!currentLesson.value || !courseLessons.value.length) return
  
  try {
    const unlearntLessons = courseLessons.value.filter(lesson => !lesson.isLearnt).slice(0, 1)
    const lessonId = lessonIdQueryNumber.value || (unlearntLessons.length > 0 ? Number(unlearntLessons[0].lesson.id) : Number(courseLessons.value[0].lesson.id))
    currentLesson.value = await api.courseLesson.show({
      courseId: route.params.courseId as string,
      id: lessonId,
      ...route.query
    })
    lessonMaterials.value = await api.lesson.materials({
      lessonId: currentLesson.value?.lesson?.id?.toString()
    })
  } catch (error) {
    console.error(error)
  }

  if (currentLesson.value?.lesson?.lessonType !== 'live' && !tab.value) {
    tab.value = schoolSetting.value?.useAiChatLesson ? 'CHAT' : 'QA'
  }
  if (currentLesson.value?.lesson?.lessonType === 'live') {
    tab.value = 'LIVECHAT'
  }
  refetchQuestionsCount()
})

// Watch currentLesson changes
watch(currentLesson, () => {
  if (!currentLesson.value) return
  // Update button states and other logic handled in composable
})

onMounted(async () => {
  await initCourse()
  onResize()

  const validTabs = ['LIVECHAT', 'CHAT', 'THREAD', 'QA', 'MATERIAL']
  const tabQueryValue = route.query.tab as string
  if (tabQueryValue && validTabs.includes(tabQueryValue)) {
    tab.value = tabQueryValue
  } else {
    initializeDefaultTab()
  }
  
  window.addEventListener('resize', onResize)
  eventBus.on(EVENTS.QUESTION_CREATED, handleQuestionCreated)
})

onUnmounted(() => {
  eventBus.off(EVENTS.QUESTION_CREATED, handleQuestionCreated)
  trackingLesson.stop()
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})

const openSubtitleModal = () => {
  nextTick(() => {
    const el = document.getElementById('subtitleModal')
    if (!el) return
    ;(window as any).bootstrap.Modal.getOrCreateInstance(el).show()
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_video_wrapper = _resolveComponent("video-wrapper")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_unref(currentLesson))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_unref(currentLesson).lesson.isExam && _unref(getBanner)('lesson_top'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_col, {
                  lg: "9",
                  sm: "12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _unref(getBanner)('lesson_top').bodyHtml
                    }, null, 8 /* PROPS */, _hoisted_4)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
            ? (_openBlock(), _createBlock(LessonPracticeHistory, {
                key: _unref(currentLesson).lesson.id,
                "lesson-id": Number(_unref(currentLesson).lesson.id),
                "course-id": Number(courseIdStr.value),
                "refresh-key": `${_unref(practiceExamId)}:${_unref(practiceHistoryRevision)}`,
                "artifact-visible": _unref(showPractice),
                onOpen: _unref(openPractice),
                onLatest: _unref(setLatestPractice)
              }, null, 8 /* PROPS */, ["lesson-id", "course-id", "refresh-key", "artifact-visible", "onOpen", "onLatest"]))
            : _createCommentVNode("v-if", true),
          (_unref(practiceExamId) || _unref(practiceGenerating))
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "practice-back",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(returnToLesson) && _unref(returnToLesson)(...args)))
                }, "← 教材に戻る"),
                (_unref(practiceGenerating))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary"
                      }),
                      _cache[13] || (_cache[13] = _createElementVNode("h3", null, "会話から練習問題を作成中", -1 /* CACHED */))
                    ]))
                  : (_unref(practiceExamId))
                    ? (_openBlock(), _createBlock(ExamArtifactWorkspace, {
                        key: _unref(practiceExamId),
                        onActiveView: _unref(setPracticeView),
                        onFinished: _unref(refreshPracticeHistory),
                        onDiscuss: _unref(discussPractice),
                        "exam-id": _unref(practiceExamId),
                        "lesson-id": Number(_unref(currentLesson).lesson.id),
                        "course-id": Number(courseIdStr.value),
                        inline: ""
                      }, null, 8 /* PROPS */, ["onActiveView", "onFinished", "onDiscuss", "exam-id", "lesson-id", "course-id"]))
                    : _createCommentVNode("v-if", true)
              ], 512 /* NEED_PATCH */)), [
                [_vShow, _unref(showPractice)]
              ])
            : _createCommentVNode("v-if", true),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            (!_unref(currentLesson).lesson.isText && !_unref(currentLesson).lesson.isExam)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_v_btn, {
                    class: "move-btn",
                    color: "black",
                    style: {"pointer-events":"auto","min-width":"40px","width":"40px","height":"40px","border-radius":"4px"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(previousLession)())),
                    disabled: _unref(disabledPreviousBtn)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { color: "white" }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    class: "move-btn",
                    color: "black",
                    style: {"pointer-events":"auto","min-width":"40px","width":"40px","height":"40px","border-radius":"4px"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goNextLesson)())),
                    disabled: _unref(disabledNextBtn)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { color: "white" }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"])
                ]))
              : _createCommentVNode("v-if", true),
            (_unref(currentLesson).lesson.isExam)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_unref(currentLesson).lesson.examId)
                    ? (_openBlock(), _createBlock(ExamArtifactWorkspace, {
                        key: _unref(currentLesson).lesson.examId,
                        onActiveView: _unref(setLessonExamView),
                        "lesson-exam": "",
                        "exam-id": Number(_unref(currentLesson).lesson.examId),
                        "lesson-id": Number(_unref(currentLesson).lesson.id),
                        "course-id": Number(courseIdStr.value)
                      }, null, 8 /* PROPS */, ["onActiveView", "exam-id", "lesson-id", "course-id"]))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (_unref(currentLesson).lesson.isText)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_unref(currentLesson).lesson.imageUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("img", {
                                      src: _unref(currentLesson).lesson.imageUrl
                                    }, null, 8 /* PROPS */, _hoisted_15)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_unref(currentLesson).lesson.isVideo)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_unref(lazyLoading))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      (_unref(currentLesson).lesson.video)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            (_openBlock(), _createBlock(_component_video_wrapper, {
                                              key: `${_unref(currentLesson).lesson.id}-${_unref(currentLesson).lesson.video}`,
                                              player: "youtube",
                                              videoId: _unref(currentLesson).lesson.video,
                                              courseId: _unref(course)?.id,
                                              lessonId: _unref(currentLesson).lesson.id,
                                              analyticsEnabled: _unref(user)?.videoAnalyticsEnabled,
                                              options: { responsive: true },
                                              onPlay: _unref(onVideoPlay),
                                              onPause: _unref(onVideoPause),
                                              onMilestone: _unref(onVideoMilestone)
                                            }, null, 8 /* PROPS */, ["videoId", "courseId", "lessonId", "analyticsEnabled", "onPlay", "onPause", "onMilestone"]))
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (_unref(currentLesson).lesson.vimeo)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            (_openBlock(), _createBlock(_component_video_wrapper, {
                                              key: `${_unref(currentLesson).lesson.id}-${_unref(currentLesson).lesson.vimeo}`,
                                              player: "vimeo",
                                              videoId: _unref(currentLesson).lesson.vimeo,
                                              courseId: _unref(course)?.id,
                                              lessonId: _unref(currentLesson).lesson.id,
                                              analyticsEnabled: _unref(user)?.videoAnalyticsEnabled,
                                              options: { responsive: true },
                                              onPlay: _unref(onVideoPlay),
                                              onPause: _unref(onVideoPause),
                                              onMilestone: _unref(onVideoMilestone)
                                            }, null, 8 /* PROPS */, ["videoId", "courseId", "lessonId", "analyticsEnabled", "onPlay", "onPause", "onMilestone"]))
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("section", _hoisted_20, [
                        _createElementVNode("h2", _hoisted_21, _toDisplayString(_unref(headerTitle)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", {
                              innerHTML: _unref(markdownParser)(_unref(currentLesson).lesson.description)
                            }, null, 8 /* PROPS */, _hoisted_24)
                          ]),
                          (_unref(currentLesson).lesson.description && _unref(currentLesson).lesson.description.length > 5)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                "aria-label": "もっと見る",
                                onClick: openSubtitleModal
                              }, " ...もっと見る "))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentLesson).lesson.teachers, (teacher) => {
                          return (_openBlock(), _createBlock(TeacherView, {
                            class: "p-1",
                            key: teacher.id,
                            teacher: teacher
                          }, null, 8 /* PROPS */, ["teacher"]))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", null, [
                            (!_unref(currentLesson).isLearnt)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  variant: "outlined",
                                  class: "mr-2",
                                  onClick: _unref(finishLesson)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { class: "me-1" }, {
                                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createTextVNode(" mdi-check-circle ", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    }),
                                    _cache[17] || (_cache[17] = _createTextVNode(" 学習を完了する ", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"]))
                              : _createCommentVNode("v-if", true),
                            (_unref(currentLesson).isLearnt)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 1,
                                  class: "mr-2",
                                  variant: "outlined",
                                  color: "success",
                                  onClick: _unref(revertFinishLesson)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { class: "me-1" }, {
                                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                        _createTextVNode(" mdi-check-circle ", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    }),
                                    _cache[19] || (_cache[19] = _createTextVNode(" 学習完了をもどす ", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"]))
                              : _createCommentVNode("v-if", true),
                            (_unref(currentLesson).isLearnt && _unref(returnGoal))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createVNode(_component_v_btn, {
                                    class: "return-goal-btn",
                                    color: "primary",
                                    variant: "flat",
                                    onClick: _unref(goBackToGoal)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { class: "me-1" }, {
                                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                          _createTextVNode("mdi-flag-variant-outline", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }),
                                      _createElementVNode("span", _hoisted_27, "ゴール（" + _toDisplayString(_unref(returnGoal).name) + "）に戻る", 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: "btn btn-secondary pe-3 text-white",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(upVote)()))
                              }, [
                                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-hand-thumbs-up pe-1" }, null, -1 /* CACHED */)),
                                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "d-none d-md-inline" }, "わかりやすい", -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(currentLesson).lesson.voteValues), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", {
                                class: "btn btn-secondary border-start ps-2 text-white",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(downVote)()))
                              }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "bi bi-hand-thumbs-down" }, null, -1 /* CACHED */)
                              ]))])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "modal-header" }, [
                                _createElementVNode("p", {
                                  class: "h5 mb-0 modal-title",
                                  id: "subtitleModalLabel"
                                }, "概要"),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn-close",
                                  "data-bs-dismiss": "modal",
                                  "aria-label": "Close"
                                })
                              ], -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("h3", _hoisted_33, _toDisplayString(_unref(headerTitle)), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(markdownParser)(_unref(currentLesson).lesson.description)
                                  }, null, 8 /* PROPS */, _hoisted_35)
                                ]),
                                _createCommentVNode(" /.container-fluid "),
                                _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                                _createElementVNode("section", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentLesson).lesson.teachers, (teacher) => {
                                        return (_openBlock(), _createBlock(TeacherView, {
                                          class: "p-1",
                                          key: teacher.id,
                                          teacher: teacher
                                        }, null, 8 /* PROPS */, ["teacher"]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                  ])
                                ])
                              ]),
                              _createCommentVNode(" /.modal-body ")
                            ]),
                            _createCommentVNode(" /.modal-content ")
                          ]),
                          _createCommentVNode(" /.modal-dialog ")
                        ]),
                        _createCommentVNode(" /.modal "),
                        _createCommentVNode(" ///.END Modal ")
                      ]),
                      _cache[53] || (_cache[53] = _createElementVNode("hr", { class: "my-2" }, null, -1 /* CACHED */)),
                      (_unref(currentLesson).lesson.lessonType == 'live')
                        ? (_openBlock(), _createElementBlock("section", _hoisted_39, [
                            _createElementVNode("button", {
                              "aria-label": "Live Chat",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#live_chat",
                              class: "w-100",
                              onClick: onBackQuestionList
                            }, [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("div", { class: "d-flex justify-content-between align-items-center fs-6" }, [
                                _createElementVNode("span", { class: "text-dark" }, " Live Chat "),
                                _createElementVNode("i", { class: "bi bi-chevron-expand" })
                              ], -1 /* CACHED */)
                            ]))]),
                            _createCommentVNode(" Modal "),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("div", {
                                      class: "h5 mb-0 modal-title",
                                      id: "live_chatLabel"
                                    }, " Live Chat "),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn-close",
                                      "data-bs-dismiss": "modal",
                                      "aria-label": "Close"
                                    })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_43, [
                                    _createVNode(LiveChat, {
                                      ref: "liveChatContainer",
                                      key: "liveChat",
                                      targetableId: _unref(currentLessonId),
                                      targetableType: 'Lesson',
                                      class: "h-full"
                                    }, null, 8 /* PROPS */, ["targetableId"])
                                  ]),
                                  _createCommentVNode(" /.modal-body ")
                                ])
                              ])
                            ]),
                            _createCommentVNode(" /.modal "),
                            _createCommentVNode(" ///.END Modal "),
                            _cache[28] || (_cache[28] = _createElementVNode("hr", { class: "my-2" }, null, -1 /* CACHED */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_44, [
                            _cache[30] || (_cache[30] = _createElementVNode("button", {
                              "aria-label": "AIチャット",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#ai_chat",
                              class: "w-100"
                            }, [
                              _createElementVNode("div", { class: "d-flex justify-content-between align-items-center fs-6" }, [
                                _createElementVNode("span", { class: "text-dark" }, " AIチャット "),
                                _createElementVNode("i", { class: "bi bi-chevron-expand" })
                              ])
                            ], -1 /* CACHED */)),
                            _createCommentVNode(" Modal "),
                            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "modal-header" }, [
                                      _createElementVNode("div", {
                                        class: "h5 mb-0 modal-title",
                                        id: "ai_chatLabel"
                                      }, " AIチャット "),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                      })
                                    ], -1 /* CACHED */)),
                                    _createElementVNode("div", _hoisted_48, [
                                      (_unref(currentLessonId) && _unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                                        ? (_openBlock(), _createBlock(MesageContainer, {
                                            "practice-enabled": true,
                                            "course-id": Number(courseIdStr.value),
                                            "practice-discussion": _unref(practiceDiscussion),
                                            "active-view": _unref(activeView),
                                            onPracticeCreated: _unref(openPractice),
                                            onPracticeGenerating: _unref(onPracticeGenerating),
                                            class: "h-100",
                                            key: _unref(currentLessonId),
                                            targetableId: _unref(currentLessonId),
                                            "using-deepseek": _unref(schoolSetting).usingDeepSeek,
                                            targetableType: 'Lesson'
                                          }, null, 8 /* PROPS */, ["course-id", "practice-discussion", "active-view", "onPracticeCreated", "onPracticeGenerating", "targetableId", "using-deepseek"]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _createCommentVNode(" /.modal-body ")
                                  ])
                                ])
                              ]),
                              _createCommentVNode(" /.modal ")
                            ])),
                            _createCommentVNode(" ///.END Modal "),
                            _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "my-2" }, null, -1 /* CACHED */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("section", _hoisted_49, [
                        _createElementVNode("button", {
                          "aria-label": "コメントを表示",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#commentModal",
                          class: "w-100",
                          onClick: onBackQuestionList
                        }, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("span", _hoisted_51, [
                              _cache[32] || (_cache[32] = _createTextVNode(" 質問 ", -1 /* CACHED */)),
                              _createElementVNode("span", null, "(" + _toDisplayString(_unref(currentLessonQuestionsCount)) + ")", 1 /* TEXT */)
                            ]),
                            _cache[33] || (_cache[33] = _createElementVNode("i", { class: "bi bi-chevron-expand" }, null, -1 /* CACHED */))
                          ])
                        ]),
                        _createCommentVNode(" Modal "),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            (questionMode.value == 'list')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("div", _hoisted_56, [
                                      _cache[34] || (_cache[34] = _createTextVNode(" 質問一覧 ", -1 /* CACHED */)),
                                      _createElementVNode("span", null, _toDisplayString(_unref(currentLesson).lesson.questionsCount), 1 /* TEXT */)
                                    ]),
                                    _cache[35] || (_cache[35] = _createElementVNode("button", {
                                      type: "button",
                                      class: "btn-close",
                                      "data-bs-dismiss": "modal",
                                      "aria-label": "Close"
                                    }, null, -1 /* CACHED */))
                                  ]),
                                  _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", _hoisted_58, [
                                      _createElementVNode("div", _hoisted_59, [
                                        (_unref(user) && _unref(user).image)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              class: "img-fluid",
                                              src: _unref(user).image.url
                                            }, null, 8 /* PROPS */, _hoisted_60))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _createElementVNode("div", { class: "col-10 d-flex align-items-center" }, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn rounded-pill bg-dark text-white",
                                          onClick: onClickNewQuestion
                                        }, " 質問を作成する ")
                                      ])
                                    ]),
                                    _createVNode(_component_v_divider, { class: "mt-2" }),
                                    _createVNode(UserQuestionList, {
                                      "relativeable-type": "Lesson",
                                      "relativeable-id": _unref(currentLesson).lesson.id,
                                      onClickQuestion: onClickQuestion
                                    }, null, 8 /* PROPS */, ["relativeable-id"])
                                  ]),
                                  _createCommentVNode(" /.modal-body ")
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createCommentVNode(" /.modal-content "),
                            (questionMode.value == 'show')
                              ? (_openBlock(), _createBlock(UserQuestionDetailModal, {
                                  key: 1,
                                  question: currentQuestion.value,
                                  onBack: onBackQuestionList
                                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                  (newQuestionCreatedFlag.value)
                                    ? {
                                        name: "notice",
                                        fn: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: "d-flex bg-success text-white p-1 justify-content-between align-items-center",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (newQuestionCreatedFlag.value = false))
                                          }, [...(_cache[36] || (_cache[36] = [
                                            _createElementVNode("div", null, "無事に投稿されました", -1 /* CACHED */),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("i", { class: "bi bi-x-lg" })
                                            ], -1 /* CACHED */)
                                          ]))])
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["question"]))
                              : _createCommentVNode("v-if", true),
                            (questionMode.value == 'new')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("div", {
                                      class: "h5 mb-0 modal-title",
                                      id: "commentModalLabel",
                                      onClick: onBackQuestionList
                                    }, [...(_cache[37] || (_cache[37] = [
                                      _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1 /* CACHED */),
                                      _createTextVNode(" 質問作成 ", -1 /* CACHED */)
                                    ]))]),
                                    _cache[38] || (_cache[38] = _createElementVNode("button", {
                                      type: "button",
                                      class: "btn-close",
                                      "data-bs-dismiss": "modal",
                                      "aria-label": "Close"
                                    }, null, -1 /* CACHED */))
                                  ]),
                                  _createElementVNode("div", _hoisted_62, [
                                    _createVNode(UserQuestionFormView, {
                                      courseId: courseIdStr.value,
                                      lessonId: _unref(currentLesson).lesson.id.toString()
                                    }, null, 8 /* PROPS */, ["courseId", "lessonId"])
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createCommentVNode(" /.modal "),
                        _createCommentVNode(" ///.END Modal "),
                        _cache[39] || (_cache[39] = _createElementVNode("hr", { class: "my-2" }, null, -1 /* CACHED */))
                      ]),
                      (_unref(courseMaterials).length > 0 || _unref(lessonMaterials).length > 0)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_63, [
                            _createElementVNode("button", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("span", _hoisted_66, [
                                  _cache[40] || (_cache[40] = _createTextVNode(" 素材一覧 ", -1 /* CACHED */)),
                                  _createElementVNode("span", null, "(" + _toDisplayString(_unref(courseMaterials).length + _unref(lessonMaterials).length) + ")", 1 /* TEXT */)
                                ]),
                                _cache[41] || (_cache[41] = _createElementVNode("i", { class: "bi bi-chevron-expand" }, null, -1 /* CACHED */))
                              ])
                            ]),
                            _createCommentVNode(" Modal "),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("div", {
                                      class: "h5 mb-0 modal-title",
                                      id: "materialModalLabel"
                                    }, " 素材一覧 "),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn-close",
                                      "data-bs-dismiss": "modal",
                                      "aria-label": "Close"
                                    })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_70, [
                                    (_unref(courseMaterials).length > 0 || _unref(lessonMaterials).length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                          (_unref(courseMaterials).length > 0)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[43] || (_cache[43] = _createElementVNode("h5", { class: "border-bottom mt-2" }, "コースの素材一覧", -1 /* CACHED */)),
                                                _createVNode(_component_v_list, {
                                                  density: "compact",
                                                  class: "mb-5"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courseMaterials), (item, index) => {
                                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: index,
                                                        onClick: _withModifiers(($event: any) => (_unref(downloadFile)(item.link)), ["prevent"])
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_72, [
                                                            _createVNode(_component_v_list_item_title)
                                                          ]),
                                                          _createElementVNode("span", null, [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.fileName), 1 /* TEXT */)
                                                              ]),
                                                              _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_73, [
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                                                _createTextVNode("mdi-download", -1 /* CACHED */)
                                                              ]))]),
                                                              _: 1 /* STABLE */
                                                            })
                                                          ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                  ]),
                                                  _: 1 /* STABLE */
                                                })
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : _createCommentVNode("v-if", true),
                                          (_unref(lessonMaterials).length > 0)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _cache[45] || (_cache[45] = _createElementVNode("h5", { class: "border-bottom" }, "レッスンの素材一覧", -1 /* CACHED */)),
                                                _createVNode(_component_v_list, { density: "compact" }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lessonMaterials), (item, index) => {
                                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: index,
                                                        onClick: _withModifiers(($event: any) => (_unref(downloadFile)(item.link)), ["prevent"])
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_74, [
                                                            _createVNode(_component_v_list_item_title)
                                                          ]),
                                                          _createElementVNode("span", null, [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.fileName), 1 /* TEXT */)
                                                              ]),
                                                              _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_75, [
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                                                _createTextVNode("mdi-download", -1 /* CACHED */)
                                                              ]))]),
                                                              _: 1 /* STABLE */
                                                            })
                                                          ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                  ]),
                                                  _: 1 /* STABLE */
                                                })
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ])
                              ])
                            ]),
                            _cache[47] || (_cache[47] = _createElementVNode("hr", { class: "my-2" }, null, -1 /* CACHED */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_unref(currentLesson).lesson.isText)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_76, [
                            _createCommentVNode(" tutorial-box is the wrapper editors scope their custom CSS to, keep it on every context "),
                            _createElementVNode("article", _hoisted_77, [
                              (_unref(currentLesson).lesson.mdBody)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "",
                                    innerHTML: _unref(currentLesson).lesson.mdBody,
                                    style: {}
                                  }, null, 8 /* PROPS */, _hoisted_78))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _cache[48] || (_cache[48] = _createElementVNode("hr", { class: "my-2" }, null, -1 /* CACHED */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_unref(currentLesson).lesson.isText)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            _createVNode(_component_v_btn, {
                              class: "text-white me-2",
                              color: "black",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(previousLession)())),
                              disabled: _unref(disabledPreviousBtn)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "me-1" }, {
                                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                    _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }),
                                _cache[50] || (_cache[50] = _createTextVNode(" 前のレッスン ", -1 /* CACHED */))
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"]),
                            _createVNode(_component_v_btn, {
                              class: "text-white",
                              color: "black",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(goNextLesson)())),
                              disabled: _unref(disabledNextBtn)
                            }, {
                              default: _withCtx(() => [
                                _cache[52] || (_cache[52] = _createTextVNode(" 次のレッスン ", -1 /* CACHED */)),
                                _createVNode(_component_v_icon, { class: "ms-1" }, {
                                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                    _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
          ], 512 /* NEED_PATCH */), [
            [_vShow, !_unref(showPractice)]
          ]),
          _createCommentVNode(" Custom header for mobile since default header is hidden "),
          _createVNode(_component_v_app_bar, {
            color: _unref(headerNavColor),
            dark: "",
            class: "header-mobile",
            style: {"position":"fixed","top":"0","left":"0","right":"0","z-index":"1000"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_v_app_bar_nav_icon, {
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (leftDrawer.value = !_unref(leftDrawer)), ["stop"])),
                  style: _normalizeStyle(_unref(hamburgerColor))
                }, null, 8 /* PROPS */, ["style"]),
                _createVNode(_component_v_toolbar_title, {
                  class: "ps-0 header-title-mobile",
                  style: _normalizeStyle({'color': _unref(headerNavTextColor)})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(headerTitle)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["style"])
              ]),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", null, [
                  (_unref(review) && _unref(review).body)
                    ? (_openBlock(), _createBlock(ReviewEditDialog, {
                        key: 0,
                        courseId: courseIdStr.value,
                        review: _unref(review)
                      }, null, 8 /* PROPS */, ["courseId", "review"]))
                    : (_openBlock(), _createBlock(ReviewDialog, {
                        key: 1,
                        courseId: courseIdStr.value,
                        onUpdateReview: _unref(updateReview)
                      }, null, 8 /* PROPS */, ["courseId", "onUpdateReview"]))
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["color"]),
          _createCommentVNode(" Navigation drawer rendered directly "),
          _createVNode(_component_v_navigation_drawer, {
            theme: "dark",
            fixed: "",
            modelValue: _unref(leftDrawer),
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(leftDrawer) ? (leftDrawer).value = $event : null)),
            app: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                class: "cursor-pointer back-home-btn",
                onClick: _unref(goToHome)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_82, [
                    _createVNode(_component_v_icon, { size: "36" }, {
                      default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                        _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex-grow-1" }, "戻る", -1 /* CACHED */))
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]),
              _createVNode(_component_v_list, {
                density: "compact",
                class: "my-course-sidebar"
              }, {
                default: _withCtx(() => [
                  (_unref(chapters).length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftBarItems).filter(item => item.type == 'header'), (item) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: `header-{item.id}`,
                            onClick: ($event: any) => (item.action())
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_83, [
                                (item && item.image)
                                  ? (_openBlock(), _createBlock(_component_v_avatar, {
                                      key: 0,
                                      size: "40"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: item.image
                                        }, null, 8 /* PROPS */, _hoisted_84)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */))
                                  : _createCommentVNode("v-if", true),
                                _createVNode(_component_v_list_item_title, {
                                  innerHTML: item.title
                                }, null, 8 /* PROPS */, ["innerHTML"])
                              ])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_85, [
                              _createVNode(_component_v_btn, {
                                class: "show-all-btn",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleShowAll()))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_86, _toDisplayString(isShowAll.value ? 'チャプターのみ表示' : 'すべて表示'), 1 /* TEXT */),
                                  _createVNode(_component_v_icon, { class: "ml-auto" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(isShowAll.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chapters), (chapter) => {
                          return (_openBlock(), _createBlock(_component_v_list_group, {
                            key: chapter.id,
                            "no-action": "",
                            color: "white",
                            class: _normalizeClass(isShowAll.value == false && _unref(leftBarItems).some(item => item.chapterId == chapter.id && item.id.toString() == _unref(currentLessonId)) ? 'v-list-item--active-expanded' : ''),
                            value: isShowAll.value || _unref(leftBarItems).some(item => (isShowAll.value === null) && item.chapterId == chapter.id && item.id.toString() == _unref(currentLessonId))
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, { class: "px-0" }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(chapter.name), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftBarItems).filter(item => item.chapterId == chapter.id), (item) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: `${chapter.id}-${item.id}`,
                                  id: `left-bar-item-${item.id}`,
                                  onClick: ($event: any) => (item.action ? item.action() : undefined),
                                  class: _normalizeClass(item.id.toString() === _unref(currentLessonId).toString() ? 'v-item--active-custom' : ''),
                                  "id-value": item.id.toString(),
                                  "current-lesson-id": _unref(currentLessonId).toString()
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_87, [
                                      (item.type != 'subheader' && item.icon)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            icon: item.icon
                                          }, null, 8 /* PROPS */, ["icon"]))
                                        : _createCommentVNode("v-if", true),
                                      (item && item.image)
                                        ? (_openBlock(), _createBlock(_component_v_avatar, {
                                            key: 1,
                                            size: "40"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: item.image
                                              }, null, 8 /* PROPS */, _hoisted_88)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */))
                                        : _createCommentVNode("v-if", true),
                                      _createVNode(_component_v_list_item_title, {
                                        innerHTML: item.title
                                      }, null, 8 /* PROPS */, ["innerHTML"])
                                    ])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onClick", "class", "id-value", "current-lesson-id"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(leftBarItems), (item, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: index,
                          id: `left-bar-item-${item.id}`,
                          disabled: item.type == 'subheader',
                          onClick: ($event: any) => (item.action ? item.action() : undefined),
                          "id-value": item.id.toString(),
                          "current-lesson-id": _unref(currentLessonId).toString(),
                          class: _normalizeClass(item.id.toString() == _unref(currentLessonId).toString() ? 'v-item--active-custom' : '')
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_89, [
                              (item.type != 'subheader' && item.icon)
                                ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.icon), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                : _createCommentVNode("v-if", true),
                              (item && item.image)
                                ? (_openBlock(), _createBlock(_component_v_avatar, {
                                    key: 1,
                                    size: "40"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: item.image
                                      }, null, 8 /* PROPS */, _hoisted_90)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                : _createCommentVNode("v-if", true),
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    innerHTML: item.title
                                  }, null, 8 /* PROPS */, _hoisted_91)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "disabled", "onClick", "id-value", "current-lesson-id", "class"]))
                      }), 128 /* KEYED_FRAGMENT */)),
                  _createCommentVNode(" スクロールは簡単にできるため、修正しました。 "),
                  _cache[56] || (_cache[56] = _createElementVNode("div", { style: {"height":"100px"} }, null, -1 /* CACHED */))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ]),
        _createVNode(_component_v_dialog, {
          modelValue: _unref(codeDialog),
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(codeDialog) ? (codeDialog).value = $event : null)),
          "max-width": "800"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, {
                  innerHTML: _unref(dialogHTML),
                  class: "d-flex pt-6"
                }, null, 8 /* PROPS */, ["innerHTML"]),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (codeDialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                        _createTextVNode("近い", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_92, [
        _createVNode(_component_v_progress_circular, {
          indeterminate: "",
          color: "primary",
          size: "48"
        })
      ]))
}
}

})